import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";

import { cn } from "@/lib/utils";
import { ErrorMessage } from "../error-message/error-message";
import { CheckboxProps } from "@radix-ui/react-checkbox";
import { Label } from "../label/label";

const Checkbox = React.forwardRef<
    React.ElementRef<typeof CheckboxPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
    <CheckboxPrimitive.Root
        ref={ref}
        className={cn(
            "peer h-4 w-4 shrink-0 rounded-sm border border-primary shadow focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
            className,
        )}
        {...props}
    >
        <CheckboxPrimitive.Indicator
            className={cn("flex items-center justify-center text-current")}
        >
            <Check className="h-4 w-4" />
        </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

/**
 * Component that renders a checkbox with a label
 */
export const LabeledCheckbox = ({
    label,
    id,
    bold = true,
    error,
    required = false,
    ...props
}: {
    label: string;
    bold?: boolean;
    error?: string;
} & CheckboxProps &
    React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>) => (
    <div className="flex flex-col gap-[var(--spacing-8)]">
        <div className="flex items-center gap-[var(--spacing-16)]">
            <Checkbox id={id} {...props} />
            <Label inputId={id} bold={bold} required={required}>
                {label}
            </Label>
        </div>
        {error && <ErrorMessage>{error}</ErrorMessage>}
    </div>
);

export { Checkbox };
